export default {"src":"/_next/static/media/shampoo.63f2f1d7.svg","height":100,"width":100};